import { render } from "./TimelineDefaultCard.vue?vue&type=template&id=3f881956&scoped=true"
import script from "./TimelineDefaultCard.vue?vue&type=script&lang=js"
export * from "./TimelineDefaultCard.vue?vue&type=script&lang=js"

import "./TimelineDefaultCard.vue?vue&type=style&index=0&id=3f881956&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f881956"]])

export default __exports__